module.exports = __webpack_public_path__ + "img/img26.c1435dd9.svg";